module.exports = __webpack_public_path__ + "static/media/Accept_terms.71f2ce99.png";